
export default {
  activeTab: "active",
  inactiveTab: "",
  header: "page-header",
  tabList: "nav nav-tabs",
  tabListRole: "tablist",
  tabRole: "presentation"
};



// WEBPACK FOOTER //
// src/common/tabs.style.js